
import React from 'react';
import { useProfileAvatarState } from './useProfileAvatarState';
import { useProfileAvatarActions } from './useProfileAvatarActions';
import ProfileAvatarDisplay from './ProfileAvatarDisplay';
import ProfileAvatarLightbox from './ProfileAvatarLightbox';
import { ProfileAvatarProps } from './types';

const ProfileAvatarContainer: React.FC<ProfileAvatarProps> = ({
  profilePictureUrl,
  initials,
  onUploadClick,
  onRemoveClick
}) => {
  const {
    state,
    setState,
    images,
    isLoadingImages,
    deleteImage,
    isDeleting,
    user
  } = useProfileAvatarState({ profilePictureUrl });

  const actions = useProfileAvatarActions({
    state,
    setState,
    user,
    profilePictureUrl,
    onUploadClick,
    images,
    deleteImage,
    isDeleting
  });

  // Convert all available images to lightbox format
  const lightboxImages = images.map(img => ({
    id: img.id,
    url: img.url,
    alt: img.alt || 'Profile Picture'
  }));

  return (
    <>
      <ProfileAvatarDisplay
        profilePictureUrl={profilePictureUrl}
        initials={initials}
        onUploadClick={onUploadClick}
        onProfilePictureClick={actions.handleProfilePictureClick}
      />
      
      <ProfileAvatarLightbox
        currentImage={state.currentImage}
        isLightboxOpen={state.isLightboxOpen}
        lightboxImages={lightboxImages}
        showDeleteConfirmation={state.showDeleteConfirmation}
        isSettingProfilePic={state.isSettingProfilePic}
        isDeleting={isDeleting}
        isCurrentImageActiveProfile={state.isCurrentImageActiveProfile}
        profilePictureUrl={profilePictureUrl}
        onClose={() => actions.setIsLightboxOpen(false)}
        onNavigate={actions.handleNavigate}
        onChooseProfilePicture={actions.handleChooseProfilePicture}
        onDeleteClick={actions.handleDeleteClick}
        onConfirmDelete={actions.handleConfirmDelete}
        onCancelDelete={actions.handleCancelDelete}
        onRemoveClick={onRemoveClick}
      />
    </>
  );
};

export default ProfileAvatarContainer;
